/**
 * [API Docs] https://api.platform.cresclab.com/api/docs#tag/OpenAPI
 */
import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  ApiKeySchema,
  CreateApiKeyRequestSchema,
  IpAllowlistSchema,
  PatchApiKeyRequestSchema,
} from "../models";

const api = makeApi([
  {
    alias: "listApiKeys",
    method: "get",
    path: "/api/v1/openapi/api-keys/",
    /** Wrapped in `data`, not a bare array. */
    response: z.object({
      data: z.array(ApiKeySchema),
    }),
  },
  {
    alias: "createApiKey",
    method: "post",
    path: "/api/v1/openapi/api-keys/",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: CreateApiKeyRequestSchema,
      },
    ],
    /** 201 with the issued key; this is the response callers read. */
    response: ApiKeySchema,
  },
  {
    alias: "updateApiKey",
    method: "patch",
    path: "/api/v1/openapi/api-keys/:credentialId/",
    parameters: [
      {
        type: "Path",
        name: "credentialId",
        schema: ApiKeySchema.shape.id,
      },
      {
        type: "Body",
        name: "body",
        schema: PatchApiKeyRequestSchema,
      },
    ],
    response: ApiKeySchema,
  },
  {
    alias: "deleteApiKey",
    method: "delete",
    path: "/api/v1/openapi/api-keys/:credentialId/",
    parameters: [
      {
        type: "Path",
        name: "credentialId",
        schema: ApiKeySchema.shape.id,
      },
    ],
    // 204 No Content with z.void() or z.never() not working here
    response: z.unknown(),
  },
  {
    alias: "getIpAllowlist",
    method: "get",
    path: "/api/v1/openapi/ip-allowlist/",
    /** A bare object, not wrapped in `data`: one resource, not a list. */
    response: IpAllowlistSchema,
  },
  {
    alias: "updateIpAllowlist",
    method: "put",
    path: "/api/v1/openapi/ip-allowlist/",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: IpAllowlistSchema,
      },
    ],
    response: IpAllowlistSchema,
  },
]);

export { api };
